import { type FC } from "react";

export const Help: FC = () => {
  return (
    <div className="vmx-page">
      <div className="vmx-page-header">
        <div>
          <div className="vmx-page-title">❓ Help</div>
          <div className="vmx-page-subtitle">
            Learn how SecureCycle works and get started with device certificate
            management.
          </div>
        </div>
      </div>

      {/* Dedicated help page for onboarding and workflow guidance. */}
      <div className="vmx-card" style={{ marginBottom: 20 }}>
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: 700,
            color: "var(--vmx-gray-900)",
            marginBottom: 8,
          }}
        >
          How SecureCycle Works
        </h2>
        <p
          style={{
            fontSize: "0.875rem",
            color: "var(--vmx-gray-500)",
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          SecureCycle helps you define certificate policies, organize devices by
          group, and automate lifecycle operations such as issuance, renewal,
          and revocation.
        </p>
      </div>

      <div className="vmx-card">
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <StepItem
            step={1}
            title="Define Certificate Policies"
            text="Choose authentication type (JWT/Certificate), key parameters, and renewal settings."
          />
          <StepItem
            step={2}
            title="Create Device Groups"
            text="Group your devices and assign an authentication policy to each group."
          />
          <StepItem
            step={3}
            title="Automated Security"
            text="SecureCycle handles certificate generation, renewal, and revocation automatically."
          />
          <StepItem
            step={4}
            title="Stay Notified"
            text="Configure webhook, SNS, Slack, or email notifications for certificate lifecycle events."
          />
          <StepItem
            step={5}
            title="Continuous Compliance"
            text="Devices stay authenticated, compliant, and secure — zero disruption."
          />
        </div>
      </div>
    </div>
  );
};

const StepItem: FC<{ step: number; title: string; text: string }> = ({
  step,
  title,
  text,
}) => (
  <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        background:
          "linear-gradient(135deg, var(--vmx-accent-dark), var(--vmx-accent))",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.875rem",
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      {step}
    </div>
    <div>
      <div
        style={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: "var(--vmx-gray-800)",
          marginBottom: 2,
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontSize: "0.8125rem",
          color: "var(--vmx-gray-500)",
          lineHeight: 1.5,
        }}
      >
        {text}
      </div>
    </div>
  </div>
);
